// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_settings/custom_events_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsCustomEventsData } from "./constants";
import type { AppSettingsCustomEventsDataParams, AppSettingsCustomEventsDataResult } from "./types";
import { isAppSettingsCustomEventsDataResult } from "@dashboardApi/apis/appSettingsCustomEventsData/validators";

export const getDataTableAppSettingsCustomEventsData = reactQueryTableFetcherAdapter(
  appSettingsCustomEventsData,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: AppSettingsCustomEventsDataParams
  ): Promise<AppSettingsCustomEventsDataResult> => {
    return fetch(
      "/app_settings/custom_events_data",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isAppSettingsCustomEventsDataResult
);
